import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'


Vue.use(axios)

new Vue({
  el: '#map-request',
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js